import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import { useRouter } from 'next/router';
import { activatePlan } from '../../tracking/selfserveTracking';
import { getPageURL } from '../../utils/tracking';
import { chatbotClicked } from '../../tracking/segment/footer';
import { activationPendingPopup } from '../../tracking/segment/selfservePage';
import { setActivationSource } from '../../utils/activation';


interface MainProps{
    closeModal: any,
    is_open: boolean,
    activation_link?:string,
    osid?:string
}
const ActivationAlert = (props: MainProps) => {
    const router = useRouter();
    const close = () => {
        if(Object.keys(router.query).length!==0 && router.query?.osid)
        {
            window.location.href = window.location.pathname
        }
        else
        {
            props.closeModal(false)
        }
        return false
    }
    const openChat = () => {
        // event.preventDefault()
        chatbotClicked({...getPageURL()})
        window.open(`https://onst.in/4dCuJA`, "noopener,noreferrer")
        window.opener = null
    }
    React.useEffect(()=>{
        if(props.is_open){
            activationPendingPopup({'osid':props.osid})
        }
    },[props?.is_open]) 
    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_alert}>
                <h5 className={styles.selfserve_alert__title}>Activation is Required</h5>
                <div className={styles.selfserve_alert__text}>
                    <p>The plan selected is not yet activated. Would you like to activate the plan?</p>
                </div>
            </div>
            <div className={commonStyles.single_button} style={{'marginBottom': '65px', 'marginTop' : "0"}}>

                <Button
                    className={commonStyles.single_btn}
                    onClick={openChat}
                    text="Chat with Agent"
                    variant="secondary"
                    style={{'fontSize': '14px'}}
                />
                <Button
                    className={commonStyles.single_btn}
                    onClick={() => {
                        // Opening Activation URL in new Tab and closing Modal

                        if (props.activation_link) {

                            router.push(props.activation_link)

                        } else {

                            router.push('/activation')
                        }
                        setActivationSource('My Plans')
                        close();
                        activatePlan();
                    }}
                    text="Activate Plan"
                    style={{'fontSize': '14px'}}
                />
            </div>
        </UIModal>
    )
}

export default ActivationAlert